import { render, staticRenderFns } from "./DateQuestion.vue?vue&type=template&id=b8e114b8&scoped=true"
import script from "./DateQuestion.vue?vue&type=script&lang=js"
export * from "./DateQuestion.vue?vue&type=script&lang=js"
import style0 from "./DateQuestion.vue?vue&type=style&index=0&id=b8e114b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e114b8",
  null
  
)

export default component.exports